export const ViewModes = {
    INTERACTIVE: 'INTERACTIVE',
    PRINT_PREVIEW: 'PRINT_PREVIEW'
};

export const PrintModes = {
    AUTO_SELECT: 'AUTO_SELECT',
    FORCE_PDF_PLUGIN: 'FORCE_PDF_PLUGIN',
    FORCE_PDF_FILE: 'FORCE_PDF_FILE'
};

export const PageModes = {
    SINGLE_PAGE: 'SINGLE_PAGE',
    CONTINUOUS_SCROLL: 'CONTINUOUS_SCROLL'
};

export const ScaleModes = {
    FIT_PAGE_WIDTH: 'FIT_PAGE_WIDTH',
    FIT_PAGE: 'FIT_PAGE',
    SPECIFIC: 'SPECIFIC'
};

export const ParameterTypes = {
    INTEGER: 'System.Int64',
    FLOAT: 'System.Double',
    STRING: 'System.String',
    DATETIME: 'System.DateTime',
    BOOLEAN: 'System.Boolean'
};

export const ParameterEditorTypes = {
    COMBO_BOX: 'COMBO_BOX',
    LIST_VIEW: 'LIST_VIEW'
};

export const ParametersAreaPositions = {
    RIGHT: 'RIGHT',
    LEFT: 'LEFT',
    TOP: 'TOP',
    BOTTOM: 'BOTTOM'
};

export const DocumentMapAreaPositions = {
    RIGHT: 'RIGHT',
    LEFT: 'LEFT'
};
